module.exports = __webpack_public_path__ + "de1c61c320971cffdb87bf6d4df7ccf5.jpg";